import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { SET_INFO_BANNER } from './types';
import { PLAYER_CONTENT_KIND } from '../constants';
import mapLinearChannelToInfoBanner from './helpers/mapLinearChannelToInfoBanner';
import mapVodContentToInfoBanner from './helpers/mapVodContentToInfoBanner';

const payloadSchema = Joi.object().keys({
  infoBanner: Joi.object().required(),
});

const playerSetInfoBannerAction = actionCreator(SET_INFO_BANNER, payloadSchema);

const contentMappers = {
  [PLAYER_CONTENT_KIND.LINEAR_CHANNEL]: mapLinearChannelToInfoBanner,
  [PLAYER_CONTENT_KIND.VOD]: mapVodContentToInfoBanner,
};

let infoBannerTimer;

export const playerSetInfoBannerThunkAction = ({
  id,
  kind = PLAYER_CONTENT_KIND.LINEAR_CHANNEL,
}) => async (dispatch, getState) => {
  if (infoBannerTimer) {
    clearTimeout(infoBannerTimer);
  }
  const infoBanner = contentMappers[kind](id, getState);

  if (infoBanner.stop) {
    const updateTimeoutInMS = differenceInMilliseconds(infoBanner.stop, new Date());
    if (updateTimeoutInMS && updateTimeoutInMS > 0) {
      infoBannerTimer = setTimeout(() => {
        dispatch(playerSetInfoBannerThunkAction({ id, kind }));
      }, updateTimeoutInMS);
    }
  }

  await dispatch(playerSetInfoBannerAction({ infoBanner }));
};
